<template>
  <div class="product-list bg-white w-100" style="color: #000000">
    <h3 class="text-center w-auto mb-5" style="font-size: 3rem">{{client}} plukkeliste</h3>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Number</th>
        <th scope="col">Reg</th>
        <th scope="col">Price</th>
        <th class="d-sm-table-cell text-center" scope="col">QTT</th>
        <th class="d-sm-table-cell text-center" scope="col">Location</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in printItems" :key="item.id" class="pointer">
        <td>{{item.name || "No name"}}</td>
        <td>{{item.partNum || "/"}}</td>
        <td>{{item.plate || "/"}}</td>
        <td>{{item.price || "/"}} kr</td>
        <td class="d-sm-table-cell text-center">{{item.qtt || 0}}</td>
        <td class="d-sm-table-cell text-center">{{item.location || '/'}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    printItems: Object,
    client: String,
  },
};
</script>

<style scoped>
table {
  color: #000000 !important;
  font-size: 21px;
  font-weight: bold;
}
</style>
